<template>
  <div>
    <van-cell @click="show = true">
      <span style="font-weight: bold; font-size: 16px;">{{ label }}</span> {{ ym }}
    </van-cell>
    <van-popup v-model="show">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirmDate"
        @cancel="cancelDate"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '账期：'
    }
  },
  data() {
    return {
      show: false,
      ym: this.value,
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2030, 11, 1)
    }
  },
  watch: {
    value: function(value) {
      this.ym = value
    }
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    confirmDate(val) {
      this.$emit('change', this.Utils.df(val, '{y}年 {m}月'), val)
      this.show = false
    },
    cancelDate() {
      this.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseYm.vue